module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "trellis-assets": "static-1.2275"
    },
    "depPathPrefixes": {
      "trellis-assets": "/trellis-assets/static-1.2275"
    },
    "bundlingPackage": "page-editor-ui",
    "bundlingPackageVersion": "static-1.38909",
    "project": "trellis-assets",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};